import styled from 'styled-components';
export const StyledUISelectWrapper = styled.div.withConfig({
  displayName: "InputWithDropdownstyle__StyledUISelectWrapper",
  componentId: "sc-1ilzrdp-0"
})(["& > div,button{padding:", " !important;height:", ";border-color:", ";background-color:", ";outline:", ";font-size:", ";line-height:", ";border-bottom-color:", ";border-radius:", ";color:", ";width:100%;text-decoration:none !important;[role='option'] > span,span:last-child{justify-content:flex-start;}", ";}"], ({
  editMode,
  theme
}) => {
  const {
    space
  } = theme;
  if (editMode) return `${space['0']} ${space['0']} ${space['100']} ${space['0']}`;
  return '';
}, ({
  editMode,
  theme
}) => editMode ? 'unset' : theme.space['1000'], ({
  editMode,
  theme
}) => editMode ? 'transparent' : theme.color['fill-tertiary-pressed'], ({
  editMode,
  theme
}) => editMode ? 'unset' : theme.color['fill-surface-raised'], ({
  editMode
}) => editMode ? 'none' : 'unset', ({
  editMode,
  theme
}) => editMode ? theme.typography['body-125'].fontSize : theme.typography['body-200'].fontSize, ({
  editMode,
  theme
}) => editMode ? theme.typography['detail-100'].lineHeight : theme.typography['body-125'].lineHeight, ({
  editMode,
  theme
}) => {
  if (editMode) return theme.color['border-core-default'];
  return theme.color['fill-tertiary-pressed'];
}, ({
  editMode,
  theme
}) => editMode ? theme.borderRadius['0'] : theme.borderRadius['100'], ({
  editMode,
  theme
}) => editMode ? theme.color['text-core-default'] : 'unset', ({
  editMode,
  theme
}) => editMode ? `
      &:focus {
        box-shadow: none;
        border-top-color: transparent;
        border-left-color: transparent;
        border-right-color: transparent;
        border-bottom-color: ${theme.color['border-core-default']};
      }
      &:hover {
        color: ${theme.color['text-core-default']};
        border-bottom-color: ${theme.color['border-core-default']} !important;

        & span[data-option-text] {
          color: ${theme.color['text-core-default']};
        }
      }
      & span[data-option-text] {
        font-size: ${theme.typography['body-100'].fontSize};
      }
    ` : '');